import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push(to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   //component: Home,
    //   component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      path: '/poster',
      name: 'poster',
      component: () =>
        import(/* webpackChunkName: "poster" */ './views/poster/index.vue')
    },
    {
      path: '/tool',
      name: 'tool',
      component: () =>
        import(/* webpackChunkName: "poster" */ './views/poster/index.vue')
    },
    {
      path: '/',
      name: 'index',
      component: () =>
        import(/* webpackChunkName: "home" */ './views/index.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          meta: {
            keepAlive: true
          },
          //component: Home,
          component: () =>
            import(/* webpackChunkName: "home" */ './views/home/index.vue')
        },
        {
          path: '/product',
          name: 'product',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "product" */ './views/product/index.vue'
            )
        },
        {
          path: '/product/detail',
          name: 'productdetail',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "productdetail" */ './views/product/detail.vue'
            )
        },
        ,
        {
          path: '/product/edit',
          name: 'productedit',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "productedit" */ './views/product/edit.vue'
            )
        },
        {
          path: '/promotion',
          name: 'promotion',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "promotion" */ './views/product/promotion.vue'
            )
        },
        {
          path: '/promotion/detail',
          name: 'promotiondetail',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "promotiondetail" */ './views/product/detail.vue'
            )
        },
        {
          path: '/about',
          name: 'about',
          component: () =>
            import(/* webpackChunkName: "about" */ './views/home/about.vue')
        },
        {
          path: '/arrangement',
          name: 'arrangement',
          component: () =>
            import(
              /* webpackChunkName: "arrangement" */ './views/home/arrangement.vue'
            )
        },
        {
          path: '/terms',
          name: 'terms',
          component: () =>
            import(/* webpackChunkName: "terms" */ './views/home/terms.vue')
        },
        {
          path: '/contactus',
          name: 'contactus',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "contactus" */ './views/home/contactus.vue'
            )
        },
        {
          path: '/article',
          name: 'article',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "article" */ './views/article/index.vue'
            )
        },
        {
          path: '/article/detail',
          name: 'articledetail',
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /* webpackChunkName: "articledetail" */ './views/article/detail.vue'
            )
        }
      ]
    }
  ]
})
